module.exports = __webpack_public_path__ + "static/about-2-02e2ce4df57388a2a7b700be53c70a40.jpg";